"use strict";var t=Function.call.bind(Object.prototype.hasOwnProperty);module.exports=t;
//# sourceMappingURL=has.js.map
